//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../no/TaggedObject.js";
let d=[[[0,"MatchedEntity",1,"NXObject",0],[0,"MatchedStatus",1,0],[0,"ParentEntity",0,"NXObject",0],[0,"ReverseDirection",1,0],[0,"Type",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Features.MatchedReferenceBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.MatchedReferenceBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.MatchedReferenceBuilder.Types = Object.freeze({
    "Curve" : "Curve", "Face" : "Face", "CurveCollector" : "CurveCollector", "FaceCollector" : "FaceCollector", "Section" : "Section", "Point" : "Point", "Vector" : "Vector", "Object" : "Object", "BodyCollector" : "BodyCollector", "Csys" : "Csys", "Plane" : "Plane", "Axis" : "Axis", "Undefined" : "Undefined"});

SPLM.Features.MatchedReferenceBuilder.ResolvedStatus = Object.freeze({
    "Initial" : "Initial", "Unresolved" : "Unresolved", "BySystem" : "BySystem", "ByUser" : "ByUser"});

export default SPLM;